<template>
  <div class="cms-html-editor-tiptap">
    <HtmlEditorTiptapToolbar class="cms-html-editor-tiptap__header" :editor="editor" />
    <editor-content class="cms-html-editor-tiptap__content" :editor="editor" />
  </div>
</template>

<script>
import HtmlEditorTiptapToolbar from './HtmlEditorTiptapToolbar.vue'
import { Editor, EditorContent } from '@tiptap/vue-2'

// extensiones Custom
import Iframe from './iframe.js'
import {
  Div,
  Col,
  Center,
  MyImage,
  Colgroup,
  CustomSpan,
  CustomTable,
  ExtendedLink,
  CustomTableRow,
  CustomParagraph,
  CustomTextStyle,
  CustomCodeBlock,
  CustomTableCell,
  CustomTableHeader
} from './extensions.js'

// extensiones tiptap
import StarterKit from '@tiptap/starter-kit'
import { Color } from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import Underline from '@tiptap/extension-underline'
import TextAlign from '@tiptap/extension-text-align'

export default {
  components: {
    EditorContent,
    HtmlEditorTiptapToolbar
  },

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editor: null,
    }
  },

  watch: {
    value(value) {
      const isSame = this.editor.getHTML() === value

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },

  mounted() {
    this.editor = new Editor({
      content: `${this.value}`,
      extensions: [
        Underline,
        CustomTextStyle,
        MyImage.configure({
          inline: true,
        }),
        StarterKit.configure({
          codeBlock: false,
          paragraph: false
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph', "image"],
        }),
        ExtendedLink.configure({
          openOnClick: false
        }),
        Highlight.configure({ multicolor: true }),
        Color.configure({
          defaultColor: '#000000', // Color por defecto
          marks: ['textColor'], // Nombre del mark para el color del texto
        }),
        CustomTable.configure({
          resizable: true,
          cellMinWidth: 123
        }),
        CustomTableRow,
        CustomTableCell,
        CustomTableHeader,
        Div,
        Col,
        Iframe,
        Center,
        Colgroup,
        CustomSpan,
        CustomCodeBlock,
        CustomParagraph
      ],
      onUpdate: () => {
        this.$emit('input', this.editor.getHTML())
      },
      autofocus: true,
    })
  },

  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss">
.cms-html-editor-tiptap {
  &__header {
    display: flex;
    flex: 0 0 auto;
    flex-wrap: wrap;
    padding: 0.25rem;
    align-items: center;
    background: #f2f2f2;
    border-bottom: 2px solid #0d0d0d;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  &__content {
    border: 1px solid #dcdcdc;
  }

  .iframe {
    &__embed {
      border: 0;
      width: 100%;
      height: 15rem;
    }

    &__input {
      border: 0;
      width: 100%;
      font: inherit;
      display: block;
      border-radius: 5px;
      padding: 0.3rem 0.5rem;
      background-color: rgba(red, 0.1);
    }
  }

  .ProseMirror {
    height: 300px;
  }

  // Estilos del bloques
  code {
    color: #fff;
    background-color: #0D0D0D;
  }

  pre {
    code {
      padding: 0;
      color: inherit;
      background: none;
      font-size: 0.8rem;
    }
  }

  figure {
    &.ProseMirror-selectednode img {
      outline: 2px solid #9c9c9c;
    }
  }

  table, table td, table th, table caption {
    border: 1px dashed #BBB;
  }
}
</style>